export default () =>  {
  const bodyStyle = getComputedStyle(document.body);
  return bodyStyle.getPropertyValue('--base-font');
}
